import type { FC } from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import CommissionPriceEdit from '../../../StudioDeviationList/_partials/CommissionPriceEdit';
import CommissionStatusEdit from '../../../StudioDeviationList/_partials/CommissionStatusEdit';
import ProductListItem, { Props } from '../ProductListItem';

const CommissionListItem: FC<Props> = ({ deviation, offset, ...props }) => {
  return (
    <ProductListItem
      deviation={deviation}
      offset={offset}
      bottomSlot={
        <Flex gap={24} alignItems="flex-end">
          <CommissionPriceEdit deviation={deviation} />
          <CommissionStatusEdit deviation={deviation} />
        </Flex>
      }
      {...props}
    />
  );
};
CommissionListItem.displayName = 'CommissionListItem';

export default CommissionListItem;
